import { ServiceData } from '@/types';

import articles from './FITNESS_ARTICLES_NO.json';
import exercises from './FITNESS_EXERCISES_NO.json';
import recipes from './FITNESS_RECIPES_NO.json';

export const FITNESS_DATA_NO: ServiceData = {
  articles,
  exercises,
  recipes,
};
